webpackJsonp([49683490770531],{

/***/ 405:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":{"totalCount":2,"edges":[{"node":{"id":"/Users/yvettezhang/Documents/FSA/practice/Portfolio/gatsby-site/src/pages/welcome.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Welcome to My Portolio Website","date":"10 January, 2018"},"fields":{"slug":"/welcome/"},"excerpt":"This website was built with Gatsby.js. Thanks for your visit!"}},{"node":{"id":"/Users/yvettezhang/Documents/FSA/practice/Portfolio/gatsby-site/src/pages/my-dive-into-binary-puzzles.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"My Dive into Binary Modulus Calculation Puzzles","date":"20 November, 2017"},"fields":{"slug":"/my-dive-into-binary-puzzles/"},"excerpt":"This blog summarizes my dive into a series of binary bitwise modulus calculation related Codewars puzzles. I’ve just become a 3 kyu player…"}}]}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---blog-37dc0d3a6a41d337b007.js